export default "__VITE_ASSET__BWm_gb01__"